import { fromJS } from 'immutable';
import { SET_SALES_YEAR } from './action';

export const initialState = fromJS({
  salesYear: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SALES_YEAR:
      return state.set('salesYear', action.salesYear);
    default:
      return state;
  }
};
